module.exports = __webpack_public_path__ + "static/media/1.21_preview.1714d66f.png";